import type Ad from 'stores/Ad';
import { makeNullableRecycler } from 'utils/Hooks';

export type AdjacentEdge = 'before' | 'after';

export interface InsertionPoint {
  id: string;
  edge: AdjacentEdge;
}

export function recycleEqualInsertionPoint(
  prev: InsertionPoint,
  next: InsertionPoint
) {
  return prev?.id === next.id && prev.edge === next.edge ? prev : next;
}

export const recycleEqualNullableInsertionPoint = makeNullableRecycler(
  recycleEqualInsertionPoint
);

export interface AdListTableRowEvent {
  ad: Ad;
}

export type AdListTableRowCallback = (event: AdListTableRowEvent) => void;

export interface AdListTableRowReorderEvent extends AdListTableRowEvent {
  insertionPoint: InsertionPoint;
}

export type AdListTableRowReorderCallback = (
  event: AdListTableRowReorderEvent
) => void;

export interface AdListTableRowCheckEvent extends AdListTableRowEvent {
  shiftKey: boolean;
  newValue: boolean;
}

export type AdListTableRowCheckCallback = (
  event: AdListTableRowCheckEvent
) => void;

export interface AdListTableReorderEvent {
  ads: Ad[];

  /**
   * Component will hold the appearance of the pending table rearrangement
   * until an event handler calls this function.
   **/
  flush: () => void;
  // TODO: Could harden the flush function a little - make it callable only
  //  once, automatically call it after a timeout, mute its effects if the
  //  component updates with new content, etc
}

export type AdListTableReorderCallback = (
  event: AdListTableReorderEvent
) => void;
